import { StatusChip } from "components/StatusChip";
import { useTranslation } from "contexts/i18nContext";
import { Summon } from "types";

interface SummonProps {
  summonData: Summon;
}

export default function SummonConfirmationStatus({ summonData }: SummonProps) {
  const { t } = useTranslation();
  return (
    <div className="bg-white rounded-xl p-5 shadow-sm space-y-4">
      <h3 className="text-base font-semibold text-gray-800">
        {t("summonConfirmedBy")}
      </h3>

      <div className="flex items-center justify-between border-t pt-3">
        <span className="text-sm text-gray-600">{t("coordinator")}</span>
        <StatusChip
          status={
            summonData?.cordinator_confirmed ? t("confirmed") : t("pending")
          }
        />
      </div>

      <div className="flex items-center justify-between">
        <span className="text-sm text-gray-600">{t("accused")}</span>
        <StatusChip
          status={summonData?.accused_confirmed ? t("confirmed") : t("pending")}
        />
      </div>
    </div>
  );
}
